<template lang="pug">
.roll-progress
  p(v-if="!targetInfo") <b>{{rollInfo.totalNumberOfCodes - rollInfo.activeCodeCount}} codes available.</b> <span>({{rollInfo.totalNumberOfCodes}} total)</span>
  p(v-else) <b>{{selectedRangeCount}} codes selected.</b> <span>({{rollInfo.totalNumberOfCodes - rollInfo.activeCodeCount - selectedRangeCount}} more available)</span>
  .progress(style="background-color: rgb(1, 220, 0)")
    .progress-bar(:style="{ width:  activatedPercent + '%'}" style="background-color: rgb(227, 231, 238)")
    .progress-bar(v-if="targetInfo" :style="{ width: targetPercent + '%'}" style="background-color: rgb(0, 79, 225)")
</template>
<script>

export default {
  props: ['rollInfo', 'targetInfo'],
  computed: {
    activatedPercent() {
      return 100 * (this.rollInfo.activeCodeCount / this.rollInfo.totalNumberOfCodes)
    },
    targetPercent() {
      if (!this.targetInfo) {
        return 0
      }
      return (100 * ((this.targetInfo.relativeRollCodeIndex + 1) / this.rollInfo.totalNumberOfCodes)) - this.activatedPercent
    },
    selectedRangeCount() {
      if (!this.targetInfo) {
        return 0
      }
      return (this.targetInfo.relativeRollCodeIndex + 1) - this.rollInfo.activeCodeCount
    }
  }
}
</script>
<style lang="scss">
.roll-progress {
  width: 300px;
  max-width: 100%;
  p {
    margin: 0 0 4px 0;
    span {
      color: #aaa;
    }
    + p {
      margin: 4px 0 14px 0;
    }
  }
  .progress {
    width: 300px;
    max-width: 100%;
    height: 8px;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/activator/components/RollProgressVisualization.vue